import { apiSlice } from "../api/apiSlice";
import { EditDone } from "../Edit/EditSlice";

export const videoApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getVideos: builder.query({
            query: () => ({
                url: "/videos",
            }),
        }),

        getVideo: builder.query({
            query: (videoId) => ({
                url: `/videos/${videoId}`
            }),
        }),

        // admin api start
        getVideosForAssignAssignment: builder.query({
            async queryFn(arg, queryApi, _extraOptions, fetchWithBQ) {
                const editAssignmentVideoId = queryApi.getState().edit?.data?.video_id

                // get all videos
                const videos = await fetchWithBQ(
                    `/videos`
                );
                if (videos.error) return { error: videos.error };

                // get all assignments
                const assignments = await fetchWithBQ(
                    `/assignments`
                );
                // filter video who not associated with any assignment
                const filteredVideo = videos?.data?.filter(video => !assignments.data?.find(assignment => assignment.video_id === video.id))
                // current editing video add
                if (editAssignmentVideoId) {
                    filteredVideo?.push(videos?.data?.find(item => item.id === editAssignmentVideoId))
                }

                return {
                    data: filteredVideo,
                };
            },
            providesTags: ["getVideosForAssignAssignment"]
        }),
        deleteVideo: builder.mutation({
            async queryFn(arg, queryApi, _extraOptions, fetchWithBQ) {

                // video delete query
                const deleteRes = await fetchWithBQ({
                    url: `/videos/${arg}`,
                    method: "DELETE"
                });
                if (deleteRes.error) return { error: deleteRes.error };
                // pessimistic videos cache update

                queryApi.dispatch(
                    apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
                        return draft.filter((item) => item.id !== arg);
                    })
                );


                // get associated quizzes
                const quizzes = await fetchWithBQ(
                    `/quizzes?video_id=${arg}`
                );
                // delete associated quizzes
                if (quizzes?.data) {
                    quizzes.data.forEach(async (item) => {
                        await fetchWithBQ({
                            url: `/quizzes/${item.id}`,
                            method: "DELETE"
                        }
                        );
                    })
                }

                // get associated assignment
                const assignment = await fetchWithBQ(
                    `/assignments?video_id=${arg}`
                );
                // delete associated assignment
                if (assignment?.data) {
                    assignment.data.forEach(async (item) => {
                        await fetchWithBQ({
                            url: `/assignments/${item.id}`,
                            method: "DELETE"
                        });
                    })
                }

                return {
                    data: deleteRes.data,
                };
            },
            invalidatesTags: ["getVideosForAssignAssignment", "AssignmentsForAdmin", "QuizzesForAdmin"]
        }),
        addVideo: builder.mutation({
            query: (data) => ({
                url: "/videos",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // pessimistic videos cache update
                try {
                    const res = await queryFulfilled;
                    dispatch(
                        apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
                            draft.push(res.data);
                        })
                    );
                } catch (err) {
                    // do nothing
                }
            },
            invalidatesTags: ["getVideosForAssignAssignment"]
        }),
        editVideo: builder.mutation({
            async queryFn(arg, queryApi, _extraOptions, fetchWithBQ) {

                // video update query
                const res = await fetchWithBQ({
                    url: `/videos/${arg.id}`,
                    method: "PATCH",
                    body: arg.data
                });
                if (res.error) return { error: res.error };
                // pessimistic videos cache update

                queryApi.dispatch(EditDone);
                queryApi.dispatch(
                    apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
                        return draft.map(item => {
                            if (Number(item.id) === Number(arg.id)) {
                                return { ...res.data }
                            } else {
                                return item
                            }
                        })
                    })
                );


                // get associated quizzes
                const quizzes = await fetchWithBQ(
                    `/quizzes?video_id=${arg.id}`
                );
                // update associated quizzes
                if (quizzes?.data) {
                    quizzes.data.forEach(async (item) => {
                        await fetchWithBQ({
                            url: `/quizzes/${item.id}`,
                            method: "PATCH",
                            body: {
                                video_title: res.data.title
                            }
                        }
                        );
                    })
                }

                // get associated assignment
                const assignment = await fetchWithBQ(
                    `/assignments?video_id=${arg.id}`
                );
                // update associated assignment
                if (assignment?.data) {
                    assignment.data.forEach(async (item) => {
                        await fetchWithBQ({
                            url: `/assignments/${item.id}`,
                            method: "PATCH",
                            body: {
                                video_title: res.data.title
                            }
                        });
                    })
                }

                return {
                    data: res.data,
                };
            },
            invalidatesTags: ["getVideosForAssignAssignment", "AssignmentsForAdmin", "QuizzesForAdmin"]
        }),
    }),
});

export const {
    useGetVideosQuery,
    useGetVideoQuery,
    useGetVideosForAssignAssignmentQuery,
    useDeleteVideoMutation,
    useAddVideoMutation,
    useEditVideoMutation } = videoApi;